import React from 'react'
import { GitHub, Globe, Linkedin, Twitter } from 'react-feather'
import styled from 'styled-components'
import { assignPrefix } from '../../../../constants'

const Wrapper = styled.div`
  width: 100%;
  box-shadow: 0px 0px 2.40026px rgba(0, 0, 0, 0.0115598), 0px 1.51px 6.63642px rgba(0, 0, 0, 0.0238066),
    0px 5.44px 15.9779px rgba(0, 0, 0, 0.0393306), 0px 22px 53px rgba(0, 0, 0, 0.07);
  border-radius: 8px;
  padding: ${p => p.theme.space[32]};
  margin-bottom: ${p => p.theme.space[32]};

  > strong {
    display: block;
    margin-top: ${p => p.theme.space[16]};
    margin-left: 72px;
    @media (max-width: ${p => p.theme.breakpoints.tabletVertical}px) {
      margin-left: 0;
    }
  }
  > p {
    margin: ${p => p.theme.space[8]} 0 ${p => p.theme.space[8]} 72px;
    @media (max-width: ${p => p.theme.breakpoints.tabletVertical}px) {
      margin-left: 0;
    }
  }
`
const Header = styled.div`
  display: flex;
  @media (max-width: ${p => p.theme.breakpoints.tabletVertical}px) {
    flex-direction: column;
  }
`
const NamePlate = styled.div`
  display: flex;
  flex: 2;
  align-items: center;
  color: ${p => p.theme.colors.gray[500]};
  > img {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    margin-right: ${p => p.theme.space[16]};
  }
  > div {
    > strong {
      font-weight: bold;
      font-size: ${p => p.theme.fontSizes[20]};
      display: block;
      margin-bottom: 4px;
      color: ${p => p.theme.colors.gray[800]};
    }
  }
`
const Socials = styled.div`
  display: flex;
  > a {
    background-color: ${p => p.theme.colors.gray[300]};
    color: ${p => p.theme.colors.gray[700]};
    display: block;
    width: 32px;
    height: 32px;
    border-radius: 16px;
    padding: 8px;
    margin-left: ${p => p.theme.space[8]};
    > svg {
      width: 16px;
      height: 16px;
    }
  }
  @media (max-width: ${p => p.theme.breakpoints.tabletVertical}px) {
    margin-top: ${p => p.theme.space[16]};
    margin-left: -8px;
  }
`

interface EmployeeProps {
  name: string
  title: string
  joinDate: string
  imgURL: string
  funFact: string
  whyPrisma: string
  socialURL?: string
  socialGithub?: string
  socialLinkedIn?: string
  socialTwitter?: string
}
const Employee: React.FC<EmployeeProps> = props => {
  return (
    <Wrapper>
      <Header>
        <NamePlate>
          <img src={assignPrefix(props.imgURL)} alt={props.name} />
          <div>
            <strong>{props.name}</strong>
            {props.title + ' | ' + props.joinDate}
          </div>
        </NamePlate>
        <Socials>
          {props.socialURL && (
            <a href={props.socialURL}>
              <Globe />
            </a>
          )}
          {props.socialLinkedIn && (
            <a href={props.socialLinkedIn}>
              <Linkedin />
            </a>
          )}
          {props.socialTwitter && (
            <a href={props.socialTwitter}>
              <Twitter />
            </a>
          )}
          {props.socialGithub && (
            <a href={props.socialGithub}>
              <GitHub />
            </a>
          )}
        </Socials>
      </Header>
      <strong>😆 Fun Fact</strong>
      <p>{props.funFact}</p>
      <strong>❓ Why are you joining Prisma?</strong>
      <p>{props.whyPrisma}</p>
    </Wrapper>
  )
}

export default Employee
